// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__0YXSL","img-styles":"Footer_img-styles__Cy8Hh"};